import React from 'react';
import { Badge } from './ui/badge';
import { getCertificateStatus, getStatusText } from '../lib/utils';
import { STATUS } from '../lib/theme';

export function StatusBadge({ daysRemaining }) {
  const status = getCertificateStatus(daysRemaining);
  const colors = STATUS[status] || STATUS.expired;

  return (
    <Badge
      className="border"
      style={{ background: colors.bg, borderColor: colors.border, color: colors.text }}
    >
      {getStatusText(status)}
    </Badge>
  );
}
